<!-- <h3>Physician Orders</h3> -->
<div id="card" header="Angular PrimeNG Card component">
    <div class="textGroup">
        <div id="top">
            <b>Medication</b>: {{medication}}
        </div>
        <div *ngIf="infusion">
            <b>Infusion Start</b>: {{infusion_start |date:'MM/dd/yyyy | HH:mm'}}
        </div>
        <div *ngIf="infusion">
            <b>Infusion End</b>: {{infusion_end |date:'MM/dd/yyyy | HH:mm'}}
        </div>
        <div *ngIf="infusion">
            <b>Basal Rate</b>: {{infusion_rate}}
        </div>
        <div id="bullets">
            <b>Scanned Required</b>: {{scanrequired}}
        </div>
        <div id="bullets">
            <b>Was Scanned</b>: {{wasscanned}}
        </div>
        <div id="bullets">
            <b>Reasons</b>: {{reasons}}
        </div>
        <div id="bullets">
            <b>Instructions</b>: {{instruction}}
        </div>
        <div id="bullets">
            <b>Admin Comments</b>: {{comments}}
        </div>
    </div>
</div>












<!-- <ng-container>
        <div [style]="{ width: '400px', height: '300px' }"  
        styleClass="shadow-2">
            <label> 
                Medication Given: {{ medication}} 
            </label>
            <label>
                Scan Required: {{ scanrequired }}
            </label>
            <label>
                Was Scanned: {{ wasscanned }}
            </label>
            <label>
                Reason(s): {{ reasons }}
            </label>
            <label>
                Instructions: {{ instruction }}
            </label>
            <label>
                Admin Comments: {{ comments }}
            </label>
        </div>
    </ng-container> -->
